jQuery($ => {
  class PageNavItem {
    constructor(element) {
      this._ = element;
      this._element = $(element);
      this._items = this._element.find('.menu-item-has-children');
      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      this._items.each((index, item) => {
        $(item).click((event) => {
          if ($(window).width() < 950) {
            this.handleItemClick(item, event);
          }
        });
      });
    }

    handleItemClick(el, event) {
      let $el = $(el);
      let $sublist = $el.children('.m-page-nav__sub-list');
      let $siblings = $el.siblings('.menu-item-has-children');

      // Check if clicked item is inside an already open submenu
      if ($el.parents('.m-page-nav__item--open').length && $sublist.length) {
        event.stopPropagation();
      }

      if ($sublist.hasClass('m-page-nav__sub-list--open')) {
        this.handleHideSubList($sublist, $el);
      } else {
        // Close all sibling submenus
        $siblings.each((_, sibling) => {
          this.handleHideSubList($(sibling).children('.m-page-nav__sub-list'), $(sibling), parent);
        });

        this.handleShowSubList($sublist, $el);
      }
    }

    handleHideSubList(sublist, el) {
      sublist.slideUp().removeClass('m-page-nav__sub-list--open');
      el.removeClass('m-page-nav__item--open');
      $('.m-page-nav__item, .m-page-nav__sub-item').not(el).not($(el).parents('.m-page-nav__item--open')).removeClass('m-page-nav__item--open');
      $('.m-page-nav__sub-list').not(sublist).not($(el).parents('.m-page-nav__item--open').children('.m-page-nav__sub-list')).slideUp().removeClass('m-page-nav__sub-list--open');


    }

    handleShowSubList(sublist, el) {
      sublist.slideDown().addClass('m-page-nav__sub-list--open');
      el.addClass('m-page-nav__item--open');
    }

  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.page_nav_item = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].page_nav = new PageNavItem(_[i], opt);
      else
        ret = _[i].page_nav[opt].apply(_[i].page_nav, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.m-page-nav').page_nav_item();
});